import { BaseRouteService } from "core/services";

class TrackingCaseDocumentFieldValueRouteService extends BaseRouteService {
    constructor() {
        super("tracking-case-document-field-values");
    }

    find(filter) {
        return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,trackingCaseDocumentId}`, filter);
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?embed,fields}`, id, options);
    }

    update(resource) {
        return super.update(`${this.base}/{id}`, resource);
    }

    batchUpdate(resource) {
        return super.batchUpdate(`${this.base}/batch`, resource);
    }
}

export default TrackingCaseDocumentFieldValueRouteService;  